import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-score-predictor-rules',
  templateUrl: './score-predictor-rules.component.html',
  styleUrls: ['./score-predictor-rules.component.scss']
})
export class ScorePredictorRulesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
